import React from 'react'
import BaseIcon from './BaseIcon'

function Linkedin(props) {
  return (
    <BaseIcon {...props}>
      <title>Linkedin Icon</title>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h32v32H0z" />
        <path d="M11.625 10.313a1.312 1.312 0 1 1-2.625 0 1.312 1.312 0 1 1 2.625 0zM11.625 13.375H9V23h2.625zM16.583 13.391h-3.208V23h3.208v-4.582c0-2.757 3.212-3.012 3.212 0V23H23v-5.38c0-5.258-5.018-5.066-6.417-2.478v-1.75z" fill="currentColor" />
      </g>
    </BaseIcon>
  )
}

Linkedin.defaultProps = {
  title: 'Linkedin Icon'
}

export default Linkedin
